import { HOME_FAQ } from "../data/nap";
import { Editable } from "./edit/Editable";
import { useContent } from "../context/ContentContext";

const fillDelivery = (a, d) => {
  if (!a.includes("{DELIVERY_FEE}")) return a;
  const fee = d?.customer_fee != null ? `$${Number(d.customer_fee).toFixed(2)}` : null;
  const free = d?.free_delivery_over ? `$${Number(d.free_delivery_over).toFixed(0)}` : null;
  return a.replace(" Delivery is {DELIVERY_FEE} and free over {FREE_OVER}", fee ? ` Delivery is ${fee}${free ? ` and free over ${free}` : ""}` : " Delivery is available");
};

export const homeFaqJsonLd = (deliveryInfo) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: HOME_FAQ.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: fillDelivery(a, deliveryInfo).replace(/<[^>]+>/g, "") } })),
});

// Plain, direct answers that lead with Indian and Punjabi; links to /tags and /places pages. Copy lives in seo_content.json (shared with the static pre-render).
export const HomeFaq = ({ deliveryInfo }) => {
  const { get, editMode } = useContent();
  return (
  <section className="mt-12 max-w-3xl" data-testid="home-faq">
    <Editable as="h2" k="homefaq.heading" fallback="Indian & Punjabi food in Lincoln Park — quick answers" label="FAQ heading" className="text-base md:text-lg font-bold" />
    <dl className="mt-4 divide-y divide-neutral-200">
      {HOME_FAQ.map(([q, a], i) => (
        <div key={q} className="py-4" data-testid={`home-faq-item-${i}`}>
          <Editable as="dt" k={`homefaq.${i}.q`} fallback={q} label={`FAQ question ${i + 1}`} className="font-bold" />
          {editMode ? (
            <Editable as="dd" k={`homefaq.${i}.a`} fallback={a} label={`FAQ answer ${i + 1}`} multiline className="text-sm text-neutral-700 mt-1 leading-relaxed" />
          ) : (
            <dd className="text-sm text-neutral-700 mt-1 leading-relaxed [&_a]:underline [&_a]:font-semibold" dangerouslySetInnerHTML={{ __html: fillDelivery(get(`homefaq.${i}.a`, a), deliveryInfo) }} />
          )}
        </div>
      ))}
    </dl>
  </section>
  );
};
